
import { defineComponent, ref, computed } from "vue";
import surveysApi from "@/api/surveys";

export default defineComponent({
  name: "Header",

  props: {
    instanceId: String,
    brand: String,
    currentLang: String,
    logoPosition: String,
    surveyStatus: { type: Boolean, default: false },
  },
  emits: ["eventAfterLangChange", "showSpin"],

  setup(props, { emit }) {
    const lang = ref<string>("");
    const curLang = computed(() => props.currentLang);

    const changeLang = async (itemLang: string) => {
      const checkedLang = itemLang;
      lang.value = itemLang;
      emit("showSpin", true);
      await surveysApi
        .changeLang(props.instanceId as string, checkedLang)
        .then(() => {
          emit("eventAfterLangChange");
        })
        .finally(() => {
          emit("showSpin", false);
        });
    };

    return {
      changeLang,
      curLang,
      lang,
    };
  },
});
